import { Injectable, inject } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalsService, StorageServices } from '../services';


@Injectable()
export class RequestInterceptorService implements HttpInterceptor {
    private globals: GlobalsService
    private storage: StorageServices
    constructor() {
        this.globals = inject(GlobalsService);
        this.storage = inject(StorageServices);
    }

    public intercept(request: HttpRequest<any>, handler: HttpHandler): Observable<HttpEvent<any>> {
        const headers: any = {
          'content-type': 'application/json',
        };


        const modifiedReq = request.clone({
            setHeaders: headers
        });

        return handler.handle(modifiedReq).pipe(
            map((event: any) => {
                return event;
            }),
            catchError((requestError: any) => {
                if (requestError instanceof HttpErrorResponse)
                  this.errorProcessing(requestError);
                return throwError(
                  (requestError.error?.detail && requestError.error?.detail[0]?.msg) ||
                    requestError.error
                );
            }));
    }

    private errorProcessing(error: any) {
        switch (error.status) {
            case 403:
            case 401:
                this.globals.spinner.text = "Access revoked and denied";
                this.globals.spinner.show();
                setTimeout(async () => {
                    this.globals.spinner.text = "Logging out";
                    this.globals.spinner.hide();
                }, 1000);
                break;
            // case 400:
            //     if (error.error.message) {
            //         this.utilService.showToast(error.error.message);
            //     } else if (error.error.errors && error.error.errors.length > 0) {
            //         error.error.errors.forEach(message => {
            //             this.utilService.showToast(message);
            //         });
            //     }
        }
    }

    private checkJwtLife(jwt: string) {
      if (
        JSON.parse(atob(jwt.split('.')[1])).exp < Math.floor(Date.now() / 1000)
      ) {
        // this.globals.spinner.text = "Access revoked and denied";
        this.globals.spinner.show();
        setTimeout(async () => {
          // this.globals.spinnerText = "Logging out";
          this.globals.spinner.hide();
          // this.globals.loggedOut();
        }, 1000);
      }
    }
}
